<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF ART &HUMANITIES</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Vocational Courses</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Diploma</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">Multimedia</td>
                        </tr>
                        <tr>
                            <td class="time">Animation</td>
                        </tr>
                        <tr>
                            <td class="time">Digital Photography</td>
                        </tr>
                        <tr>
                            <td class="time">Digital Marketing</td>
                        </tr>
                        <tr>
                            <td class="time">Digital Film Making</td>
                        </tr>
                        <tr>
                            <td class="time">Graphics Designing</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Diploma in Multimedia </b>
                    – The Diploma in Multimedia program at ARNI School of Art & Humanities is designed to provide
                    students with a comprehensive understanding of the world of multimedia, including graphic design,
                    animation, video production, web development, and interactive media. This program emphasizes
                    creative thinking, technical proficiency, and industry-specific skills to prepare students for
                    careers in the dynamic field of multimedia.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b>
                </p>
                <ul>
                    <li> Introduction to Computers</li>
                    <li> Computer Graphics</li>
                    <li> Digital Movie Production</li>
                    <li> Digital Image Editing</li>
                    <li> 2D Animation</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b>
                </p>
                <ul>
                    <li> Advanced Computer Graphics</li>
                    <li> Digital Audio and Sound Recording</li>
                    <li> Visual Effects</li>
                    <li> Web Designing using HTML</li>
                    <li> 3D Animation</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b>
                </p>
                <ul>
                    <li> Organic and Inorganic 3D Modeling</li>
                    <li> Rigging and Animation</li>
                    <li> Texturing and Animation</li>
                    <li> VR/AR Developer</li>
                    <li> Project Work</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b>
                </p>
                <ul>
                    <li> Macromedia Director</li>
                    <li> Audio Video Mixing</li>
                    <li> Sound Forge</li>
                    <li> Sound Designer</li>
                    <li> UI/UX Designer</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Diploma in Animation </b>
                    –The Diploma in Animation at ARNI School of Art & Humanities equips students with essential skills
                    in animation, combining creativity with technical proficiency. It covers traditional and digital
                    animation techniques, teaches content creation across film, television, and video games, and
                    utilizes industry-standard tools and software.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b> : Foundation of Animation
                </p>
                <ul>
                    <li>Introduction to Animation</li>
                    <li> Basic Drawing Techniques</li>
                    <li> Digital Graphics and Design Tools</li>
                    <li> Character Design Fundamentals</li>
                    <li> 2D Animation Principles</li>
                    <li> History of Animation</li>
                    <li> English I</li>
                    <li> Behavioral Science I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b> : Advanced Animation Techniques
                </p>
                <ul>
                    <li> Advanced 2D Animation</li>
                    <li> Stop Motion Animation</li>
                    <li> 3D Modeling and Animation Introduction</li>
                    <li>Storyboarding and Layout Design</li>
                    <li>Motion Graphics</li>
                    <li> Sound for Animation</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b> : 3D Animation and Visual Effects
                </p>
                <ul>
                    <li> Advanced 3D Animation</li>
                    <li> Visual Effects (VFX)</li>
                    <li> Character Rigging and Animation</li>
                    <li> Digital Sculpting and Texturing</li>
                    <li> Principles of Cinematography for Animation</li>
                    <li> Animation Production Techniques</li>
                    <li> Project</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b> : Animation Production and Portfolio
                    Development
                </p>
                <ul>
                    <li> Complete Animation Production</li>
                    <li> Advanced Visual Effects</li>
                    <li> Portfolio Development for Animators</li>
                    <li> Advanced 3D Modeling</li>
                    <li> Internship / Live Project</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Diploma in Digital Photography </b>
                    – The Diploma in Digital Photography at ARNI School of Art & Humanities aims to develop creative
                    minds into professional photographers, combining theoretical learning with practical experience,
                    covering camera handling and advanced post-production techniques.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b>
                </p>
                <ul>
                    <li> History and Fundamentals of Photography</li>
                    <li> Digital Camera & Equipment</li>
                    <li> Photography Basics – Lighting</li>
                    <li> Introduction to Photo Editing Software</li>
                    <li> English Communication Skills</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b>
                </p>
                <ul>
                    <li> Advanced Camera Techniques</li>
                    <li> Portrait and Fashion Photography</li>
                    <li> Product and Commercial Photography</li>
                    <li> Photojournalism</li>
                    <li> Advanced Photo Editing</li>
                    <li> Photography Business and Marketing</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b>
                </p>
                <ul>
                    <li> Landscape and Nature Photography</li>
                    <li> Architecture and Interior Photography</li>
                    <li> Fashion & Editorial Photography</li>
                    <li> Digital Photography in Social Media</li>
                    <li> Video Editing for Photographers</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b>
                </p>
                <ul>
                    <li> Portfolio Development</li>
                    <li> Mastering Studio Photography</li>
                    <li> Photo Book Production</li>
                    <li> Conceptual and Fine Art Photography</li>
                    <li> Final Project (Thesis/Portfolio)</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Diploma in Digital Marketing </b>
                    – The Diploma in Digital Management at ARNI School of Arts and Humanities is designed to equip
                    students with the essential knowledge, skills, and strategies required to analyze, plan, market,
                    produce, and evaluate an event. The Diploma in Disaster Event Management consists of two semesters,
                    covering core subjects, practical training, and industry projects.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b>
                </p>
                <ul>
                    <li> Communication Skills</li>
                    <li> Introduction to Digital Marketing</li>
                    <li> Social Media Marketing</li>
                    <li> AdWords & PPC</li>
                    <li> Content Marketing & Copywriting</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b>
                </p>
                <ul>
                    <li> SEO</li>
                    <li> Affiliate Marketing</li>
                    <li> Google Analytics</li>
                    <li> Email Marketing</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Diploma in Digital Film Making</b>
                    – The Diploma in Digital Filmmaking at ARNI University is designed to provide students with
                    comprehensive knowledge and hands-on experience in the world of filmmaking. This two-year course
                    focuses on the principles of filmmaking, digital media production, visual storytelling, and
                    technical expertise in editing, cinematography, and sound design. Students will develop the skills
                    required to produce high-quality films and digital content.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b>
                </p>
                <ul>
                    <li> Introduction to Film Industry</li>
                    <li> Basics of Cinematography</li>
                    <li> Digital Filmmaking Equipment</li>
                    <li> Scriptwriting and Storytelling</li>
                    <li> Film Editing Basics</li>
                    <li> Introduction to Sound Design</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b>
                </p>
                <ul>
                    <li> Visual Composition and Design</li>
                    <li> Media Ethics and Legalities</li>
                    <li> Advanced Cinematography and Lighting</li>
                    <li> Advanced Editing Techniques</li>
                    <li> Directing for Film</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b>
                </p>
                <ul>
                    <li> Production Management and Budgeting</li>
                    <li> Documentary Filmmaking</li>
                    <li> Film Sound and Music</li>
                    <li> Film Analysis and Critique</li>
                    <li> Final Project Development</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b>
                </p>
                <ul>
                    <li> Film Production and Shooting</li>
                    <li> Film Post-Production & Visual Effects</li>
                    <li> Marketing and Distribution of Films</li>
                    <li> Final Film Project and Presentation</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Diploma in Graphics Designing </b>
                    – The Diploma in Graphic Designing at ARNI University is a two-year program that teaches students
                    the fundamentals of visual communication, creativity, and technical expertise for designing
                    impactful graphics across print, digital, and web platforms, including industry-standard design
                    software, typography, branding, and UI design.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b>
                </p>
                <ul>
                    <li> Colour Theory for Computer</li>
                    <li> Computer Studies</li>
                    <li> Generic Skills</li>
                    <li> Visual Communication</li>
                    <li> Team Management</li>
                    <li> Basic Information</li>
                    <li> Sound Principles</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b>
                </p>
                <ul>
                    <li> Design: Character</li>
                    <li> Principles of Management</li>
                    <li> Background and Concept</li>
                    <li> Drawing as Basis for 2D and 3D Animation</li>
                    <li> Language Career Planning and Guidance</li>
                    <li> Digital Publishing</li>
                    <li> Graphics Principle</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b>
                </p>
                <ul>
                    <li> Typographic Design</li>
                    <li> Animation the Production Process</li>
                    <li> Method of Design Introduction to Multimedia</li>
                    <li> Sound Recording</li>
                    <li> Breakdown: Voice</li>
                    <li> Digital Portfolio Presentation</li>
                    <li> Modeling Using CAD</li>
                    <li> Web Design</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b>
                </p>
                <ul>
                    <li> Digital Portfolio Development</li>
                    <li> Industrial Training</li>
                    <li> Project I</li>
                    <li> Music and Effects Film</li>
                    <li> Web Campaign Implementation</li>
                    <li> Scripting for the Web</li>
                    <li> Multimedia Authoring</li>
                    <li> Live Project</li>
                    <li> Case Study I</li>
                </ul>
            </div>

        </div>

    </div>
</section>
